export default {
    msTitle: 'Mi suscripción',
    msSubtitle: 'Consulta tu plan, tu consumo y gestiona tus add-ons',
    msTabPlan: 'Mi plan',
    msTabAddons: 'Add-ons',
    msTabChange: 'Cambiar plan',
    msTabHistory: 'Historial',
    msTabNotifications: 'Notificaciones',

    msCurrentPlan: 'Plan actual',
    msNoPlan: 'Aún no tienes un plan asignado',
    msNoPlanHint: 'Contacta al administrador para activar tu suscripción',
    msPrice: 'Precio',
    msBillingMonthly: 'Mensual',
    msBillingYearly: 'Anual',
    msTargetProfile: 'Perfil',
    msCycleStart: 'Inicio del ciclo',
    msCycleEnd: 'Renueva el',
    msIncludedModules: 'Módulos incluidos',
    msIncludedFeatures: 'Características',
    msNoModules: 'Este plan no tiene módulos configurados',
    msUnlimited: 'Ilimitado',
    msPendingRequestBanner: 'Tienes una solicitud de cambio de plan pendiente de aprobación',

    msUsageTitle: 'Consumo del ciclo actual',
    msUsageSubtitle: 'Uso de tus cuotas en el periodo vigente',
    msUsed: 'Usado',
    msLimit: 'Límite',
    msRemaining: 'Restante',
    msNearLimit: 'Cerca del límite',
    msAtLimit: 'Límite alcanzado',
    msUpTo: 'Hasta',
    msMax: 'máx. por elemento',
    msPerParentHint: 'El límite es por cada elemento (activo, alcance, target), no un total. Aquí ves tu elemento más lleno.',
    msExceeded: 'Excedido',
    msNoUsage: 'No hay datos de consumo disponibles',

    msAddonsTitle: 'Add-ons contratados',
    msAddonsSubtitle: 'Capacidad adicional sobre tu plan',
    msContractAddon: 'Contratar add-on',
    msCancelAddon: 'Cancelar',
    msAddonQuantity: 'Cantidad',
    msAddonMonthlyCost: 'Costo mensual',
    msAddonTotalCost: 'Costo mensual total',
    msAddonActiveSince: 'Activo desde',
    msNoAddons: 'No tienes add-ons contratados',
    msSelectAddon: 'Selecciona un add-on',
    msAddonModule: 'Módulo',
    msAddonAttribute: 'Atributo',
    msAddonUnitValue: 'Valor por unidad',
    msAddonPricePerUnit: 'Precio por unidad',
    msContract: 'Contratar',
    msConfirmCancelAddon: '¿Deseas cancelar este add-on?',
    msAddonContracted: 'Add-on contratado correctamente',
    msAddonCancelled: 'Add-on cancelado',
    msAddonContractError: 'Error al contratar el add-on',
    msAddonCancelError: 'Error al cancelar el add-on',
    msCancelConflict: 'El consumo actual supera el límite resultante; no es posible cancelar ahora',

    msChangeTitle: 'Solicitar cambio de plan',
    msChangeSubtitle: 'Elige un nuevo plan; tu solicitud será revisada por el administrador',
    msSelectNewPlan: 'Nuevo plan',
    msRequestChange: 'Solicitar cambio',
    msChangeNotes: 'Notas (opcional)',
    msPendingRequest: 'Ya tienes una solicitud pendiente',
    msChangeRequested: 'Solicitud de cambio enviada',
    msChangeError: 'Error al solicitar el cambio de plan',
    msSamePlan: 'Este ya es tu plan actual',
    msUpgrade: 'Mejora',
    msDowngrade: 'Reducción',

    msHistoryTitle: 'Historial de cambios de plan',
    msNoHistory: 'No hay cambios de plan registrados',
    msHistoryDate: 'Fecha',
    msHistoryFrom: 'Plan anterior',
    msHistoryTo: 'Plan nuevo',
    msHistoryType: 'Tipo',
    msHistoryDetail: 'Detalle',
    msTypeInitial: 'Inicial',
    msTypeUpgrade: 'Mejora',
    msTypeDowngrade: 'Reducción',
    msTypeAddonContracted: 'Add-on contratado',
    msTypeAddonCancelled: 'Add-on cancelado',
    msFilterAll: 'Todos',
    msFilterPlan: 'Planes',
    msFilterAddon: 'Add-ons',
    msFilterFrom: 'Desde',
    msFilterTo: 'Hasta',

    msNotificationsTitle: 'Notificaciones de consumo',
    msNoNotifications: 'No tienes notificaciones',
    msNotifWarning: 'Consumo cercano al límite',
    msNotifCritical: 'Consumo crítico',
    msNotifCycle: 'Ciclo',
    msMarkRead: 'Marcar como leída',

    msLoadError: 'Error al cargar la información',
};
